import { OpeningTime, Typo3Openings } from '@/types/typo3/openings'

export const replaceTimePrefix = (
  timeString: string,
  oldPrefix: string,
  newPrefix: string
): string =>
  timeString.startsWith(oldPrefix)
    ? timeString.replace(oldPrefix, newPrefix)
    : timeString

export const getCurrentTimeFormatted = (): string => {
  const now = new Date()
  let hours = now.getHours()
  const minutes = now.getMinutes().toString().padStart(2, '0')
  const hourMapping: { [key: number]: number } = {
    0: 24,
    1: 25,
    2: 26,
    3: 27,
    4: 28
  }

  hours = hourMapping[hours] || hours
  return `${hours.toString().padStart(2, '0')}:${minutes}`
}

export const getOpeningTimes = (
  openingTimes: OpeningTime[]
): { openTime: string; closeTime: string; isOpen: boolean } => {
  const currentTime = getCurrentTimeFormatted()
  let intervalPrevious = { opens: '', closes: '' }

  for (const interval of openingTimes) {
    let { closes } = interval
    const { opens } = interval
    closes = replaceTimePrefix(closes, '00:', '24:')
    closes = replaceTimePrefix(closes, '01:', '25:')
    closes = replaceTimePrefix(closes, '02:', '26:')
    closes = replaceTimePrefix(closes, '03:', '27:')
    closes = replaceTimePrefix(closes, '04:', '28:')

    if (currentTime >= opens && currentTime < closes) {
      return {
        openTime: '',
        closeTime: interval.closes,
        isOpen: true
      }
    }
    if (currentTime < opens && intervalPrevious.opens === '') {
      intervalPrevious = { opens, closes }
    }
  }

  return {
    openTime: intervalPrevious.opens,
    closeTime: intervalPrevious.closes,
    isOpen: false
  }
}

export const handleClosedStatus = (
  openings: Typo3Openings,
  D: any,
  setBadgeLabel: any,
  setNextOpen: any,
  setIsOpenToday: any
) => {
  if (
    !openings ||
    !openings?.weekOpenings ||
    openings.weekOpenings.length ||
    !openings.keyForNextOpeningDay
  ) {
    return null
  }

  const nextOpeningDay =
    openings &&
    openings?.weekOpenings &&
    openings?.keyForNextOpeningDay &&
    openings?.weekOpenings[openings?.keyForNextOpeningDay]
  if (nextOpeningDay) {
    const nextOpeningTime = nextOpeningDay.openingTimes?.[0]?.opens
    const dayLabel = D[`fe.date.day.${nextOpeningDay.isoWeekday}`]
    const openingInfo = nextOpeningTime
      ? `${dayLabel} ${D['fe.plugin.openings.at']} ${nextOpeningTime} ${D['fe.plugin.openings.h']}`
      : dayLabel

    setBadgeLabel([D['fe.plugin.openings.nowClosed']])
    setNextOpen(`${D['fe.plugin.openings.opens']} ${openingInfo}`)
    setIsOpenToday('closed')
  } else {
    setBadgeLabel([D['fe.plugin.openings.nowClosed']])
    setIsOpenToday('closed')
  }
}
